import { clearLocalStorageValue, getLocalStorageValue, setLocalStorageValue } from 'utility-belt/storage';
export const LocalStorage = {
  get: getLocalStorageValue,
  set: setLocalStorageValue,
  clear: clearLocalStorageValue
};